/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// INFRASTRUCTURE START
  export type StandardError = globalThis.Error;
  export type Error500s = 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 510 | 511;
  export type ErrorStatuses = 0 | Error500s;
  export type ErrorResponse = FetchResponse<unknown, ErrorStatuses>;

  export type FetchResponseOfError = {
    data: null;
    error: StandardError;
    status: ErrorStatuses;
    args: FetchArgs;
  };

  export type FetchResponseOfSuccess<TData, TStatus extends number = 0> = 
  {
    data: TData;
    error: null;
    status: TStatus;
    args: FetchArgs;
    responseHeaders: Headers;
  };

  export type FetchResponse<TData, TStatus extends number = 0> = 
    TStatus extends ErrorStatuses ? FetchResponseOfError: FetchResponseOfSuccess<TData, TStatus>;

  export type TerminateRequest = null;
  export type TerminateResponse = null;

  export type Configuration = {
    apiUrl: string | (() => string);
    jwtKey: string | undefined | (() => string | null | undefined);
    requestMiddlewares?: Array<{
      name: string;
      fn: (request: FetchArgs) => FetchArgs | TerminateRequest;
    }>;
    responseMiddlewares?: Array<{
      name: string;
      fn: <TData, TStatus extends number>(
        response: FetchResponse<TData, TStatus>,
      ) => FetchResponse<TData, TStatus> | TerminateResponse;
    }>;
  };

  let CONFIG: Configuration = {
    apiUrl: () => "",
    jwtKey: undefined,
    requestMiddlewares: [],
    responseMiddlewares: [],
  };

  export function setupClient(configuration: Configuration) {
    const uniqMiddlewares = <
      T extends
        | Configuration["requestMiddlewares"]
        | Configuration["responseMiddlewares"],
    >(
      oldMiddlewares: T,
      newMiddlewares: T,
    ): T => {
      return [
        ...(oldMiddlewares?.filter(
          middleware => !newMiddlewares?.some(m => m.name === middleware.name),
        ) ?? []),
        ...(newMiddlewares ?? []),
      ] as T;
    };
  
    CONFIG = {
      ...CONFIG,
      ...configuration,
      requestMiddlewares: uniqMiddlewares(CONFIG.requestMiddlewares, configuration.requestMiddlewares),
      responseMiddlewares: uniqMiddlewares(CONFIG.responseMiddlewares, configuration.responseMiddlewares),
    };
  }

  export function getApiUrl() {
    if (typeof CONFIG.apiUrl === "function") {
      return CONFIG.apiUrl();
    }
    return CONFIG.apiUrl;
  }

  export type Termination = {
    termination: {
      name: string;
    };
  };

  export function processRequestWithMiddlewares(
    request: FetchArgs
  ): FetchArgs | Termination {
    for (const middleware of CONFIG.requestMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(request);
        if (middlewareResponse === null) {
          return { termination: { name: middleware.name } };
        }
        request = middlewareResponse;
      } catch (e) {
        console.error("Request middleware error", e);
      }
    }
    return request;
  }

  export function processResponseWithMiddlewares<TData, TStatus extends number>(
    response: FetchResponse<TData, TStatus>,
  ): FetchResponse<TData, TStatus | 0> {
    for (const middleware of CONFIG.responseMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(response);
        if (middlewareResponse === null) {
          return {
            status: 0,
            args: response.args,
            data: null,
            error: new Error(
              `Response terminated by middleware: ${middleware.name}`
            ),
          } satisfies FetchResponseOfError;
        }
        response = middlewareResponse;
      } catch (e) {
        console.error("Response middleware error", e);
      }
    }
    return response;
  }

  export type FetchArgsOptions = Omit<RequestInit, "method" | "redirect" | "body">;

  export type FetchArgs = {
    url: string;
    options: RequestInit;
  }

  export type UriComponent = string | number | boolean;
  export type ParamsObject = {
    [key: string]: UriComponent | UriComponent[] | undefined | null;
  };

  export async function fetchJson<TData>(args: FetchArgs): Promise<FetchResponse<TData, number> | FetchResponseOfError> {
    const errorResponse = (error: StandardError, status: number, args: FetchArgs) => {  
      const errorResponse = {
        status: status as ErrorStatuses,
        args,
        data: null,
        error,
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    const errorStatus = (args: FetchArgs) => {
      const errorResponse = {
        status: 0,
        args,
        data: null,
        error: new Error("Network error"),
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    try {
      const fetchRequest = processRequestWithMiddlewares(args);

      if ("termination" in fetchRequest) {
        const terminationResponse = {
          status: 0,
          args,
          data: null,
          error: new Error(
            `Request terminated by middleware: ${fetchRequest.termination.name}`
          ),
        } satisfies FetchResponseOfError;

        return processResponseWithMiddlewares(terminationResponse);
      }

      const fetchResponse: Response = await fetch(fetchRequest.url, fetchRequest.options);
      const status = fetchResponse.status;
      try {
        const json = await fetchResponse.json();
        const response = {
          data: json,
          status: fetchResponse.status,
          args,
          error: null,
          responseHeaders: fetchResponse.headers,
        };
        return processResponseWithMiddlewares(response);
      } catch (error) {
        return errorResponse(error as StandardError, status, args);
      }
    } catch {
      return errorStatus(args);
    }
  }

  export function getJwtKey(): string | null | undefined {
    if (typeof CONFIG.jwtKey === "function") {
      return CONFIG.jwtKey();
    }

    if (typeof CONFIG.jwtKey === "string") {
      return localStorage.getItem(CONFIG.jwtKey);
    }

    return undefined;
  } 
  
  
 function getApiRequestData<Type extends any>(
    requestContract: Type | undefined,
    isFormData: boolean = false
  ): FormData | Type | {} {
  
    if (!isFormData) {
      return requestContract !== undefined ? requestContract : {};
    }
  
    //multipart/form-data
    const formData = new FormData();
  
     if (requestContract) {
      Object.keys(requestContract).forEach(key => {
        const value = requestContract[key as keyof Type];
        const isKeyArrayAndValueIterable = key.endsWith('[]') && typeof (value as any)[Symbol.iterator] === 'function';
        const values = isKeyArrayAndValueIterable ? Array.from(value as Iterable<any>) : [value];
          for (const val of values) {
              if (val === undefined) {
                  continue;
              }
              if (val === null) {
                  formData.append(key, '');
              } else if (val instanceof File) {
                  formData.append(key, val);
              } else if (typeof val === 'object' && val !== null) {
                  formData.append(key, JSON.stringify(val));
              } else {
                  formData.append(key, val);
              }
          }
      });
    }
  
    return formData;
  }

  
function updateHeaders(headers: HeadersInit) {
  const token = getJwtKey();
  if (headers instanceof Headers) {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    if (!headers.has("Authorization") && !!token) {
      headers.append("Authorization", token);
    }
    return;
  }

  if (Array.isArray(headers)) {
    if (!headers.find(([key]) => key === "Content-Type")) {
      headers.push(["Content-Type", "application/json"]);
    }
    if (!headers.find(([key]) => key === "Authorization") && !!token) {
      headers.push(["Authorization", token]);
    }
    return;
  }

  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (!headers.Authorization && !!token) {
    headers.Authorization = token;
  }
}

function removeContentTypeHeader(headers: HeadersInit) {
  if (headers instanceof Headers) {
    headers.delete("Content-Type");
    return;
  }

  if (Array.isArray(headers)) {
    return headers.filter(([key]) => key !== "Content-Type");
  }

  delete headers["Content-Type"];
}

export function createRequest<TRequest>(
  method: string,
  request: TRequest | undefined,
  options: FetchArgsOptions | undefined,
  url: string,
  paramsObject: ParamsObject = {},
) {
  const fetchOptions = options ?? {};

  if (!fetchOptions.headers) {
    fetchOptions.headers = new Headers();
  }

  updateHeaders(fetchOptions.headers);
  if (request instanceof FormData) {
    removeContentTypeHeader(fetchOptions.headers);
  }

  const body = (request instanceof FormData) ? request : JSON.stringify(request);
  const maybeQueryString = getQueryParamsString(paramsObject);

  const requestOptions: RequestInit = {
    ...fetchOptions,
    method,
    body,
    redirect: "follow",
  };

  return { options: requestOptions, url: `${url}${maybeQueryString}` } as FetchArgs;
}

export function getQueryParamsString(paramsObject: ParamsObject = {}) {
	const queryString = Object.entries(paramsObject)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map(val => `${encodeURIComponent(key)}=${encodeURIComponent(
            val,
          )}`)
          .join('&');
      }
      // Handling non-array parameters
      return value !== undefined && value !== null 
        ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` 
        : '';
    })
    .filter(part => part !== '')
    .join("&");

	return queryString.length > 0 ? `?${queryString}` : '';
}

export function apiPost<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("POST", request, options, url, paramsObject));
}

export function apiGet<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("GET", undefined, options, url, paramsObject));
}

export function apiPut<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PUT", request, options, url, paramsObject));
}

export function apiDelete<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("DELETE", undefined, options, url, paramsObject));
}

export function apiPatch<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PATCH", request, options, url, paramsObject));
}
// INFRASTRUCTURE END

export type FileResponse = {
  data: Blob;
  fileName?: string;
}

export type ApiProblemDetails = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export type ErrorDetail = {
	code: ErrorCode;
	message?: string | null;
};

export enum ErrorCode {
	Unspecified = "Unspecified",
	OutOfRange = "OutOfRange",
	NotFound = "NotFound",
	Invalid = "Invalid",
	Forbidden = "Forbidden",
	TooManyRequests = "TooManyRequests",
	Conflict = "Conflict",
	NullOrEmpty = "NullOrEmpty",
	Unauthorized = "Unauthorized",
	ExternalProviderNotAvailable = "ExternalProviderNotAvailable"
};

export type ProblemDetails = {
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export type EntityListOfUserListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: UserListItemDto[];
};

export type UserListItemDto = {
	userID: number;
	login: string;
	firstName: string;
	lastName: string;
	status: string;
	dateCreated: string;
	accessRoles: AccessRoleDto[];
};

export type AccessRoleDto = {
	accessRoleID: number;
	name: string;
};

export type UserDetailDto = {
	userID: number;
	login: string;
	email: string;
	firstName?: string | null;
	lastName?: string | null;
	lastSignInDate?: string | null;
	phone?: string | null;
	userIdentityProviders: IdentityProvider[];
	profilePicture?: string | null;
	status: UserStatus;
	accessRoles: AccessRoleDto[];
};

export enum IdentityProvider {
	Application = "Application",
	Google = "Google",
	BankID = "BankID"
};

export enum UserStatus {
	Unknown = "Unknown",
	Active = "Active",
	Disabled = "Disabled",
	WaitingForEmailConfirmation = "WaitingForEmailConfirmation"
};

export type UpdateUserQuery = {
	userID: number;
	login: string;
	email: string;
	firstName?: string | null;
	lastName?: string | null;
	lastSignInDate?: string | null;
	phone?: string | null;
	userIdentityProviders: IdentityProvider[];
	profilePicture?: string | null;
	status: UserStatus;
	accessRoles: AccessRoleDto[];
};

export type SaveUserNotificationSettingsCommandResult = {};

export type UserNotificationUpdateRequest = {
	isEmailNotificationActive: boolean;
};

export type MemoryStream = {
	canRead: boolean;
	canWrite: boolean;
	canSeek: boolean;
	canTimeout: boolean;
	length: number;
	position: number;
	readTimeout: number;
	writeTimeout: number;
	capacity: number;
};

export type ExportDevicesCommand = {
	filteredDevices: string[];
};

export type GetCodeListCollectionQueryResult = {
	countries: CodeListItemDto[];
};

export type CodeListItemDto = {
	id: number;
	code: string;
	name: string;
};

export type CodeListFileDto = {
	codeListFileID: number;
	path: string;
	folderPath: string;
	fileName: string;
	downloadUrl?: string | null;
	version: number;
	isActive: boolean;
	uploadedAt: string;
	uploadedBy: string;
	uploadedByName?: string | null;
	size: number;
	contentHash?: string | null;
	dateCreated: string;
	dateUpdated?: string | null;
};

export type UploadCodeListFileCommandResult = {
	codeListFileID: number;
	version: number;
	path: string;
};

export type ActivateCodeListFileVersionCommandResult = {
	activatedVersion: number;
	alreadyActive: boolean;
};

export type DeleteCodeListFileCommandResult = {
	deletedVersions: number;
};

export type GetInstitutionDownloadConfigsQueryResult = {
	items: InstitutionDownloadConfigDto[];
	offset: number;
	limit: number;
	totalCount: number;
	enabledCount: number;
	downloadScheduleCron?: string | null;
};

export type InstitutionDownloadConfigDto = {
	institutionDownloadConfigID: number;
	institutionCode: string;
	downloaderName: string;
	category: string;
	country: string;
	folderPath: string;
	enabled: boolean;
	configuration?: { [key: string | number]: string } | null;
	configurationSchema?: ConfigurationFieldSchemaDto[] | null;
	lastRunAt?: string | null;
	lastRunStatus?: string | null;
	lastRunHttpCode?: number | null;
	lastRunException?: string | null;
	dateCreated: string;
	dateUpdated?: string | null;
};

export type ConfigurationFieldSchemaDto = {
	key: string;
	label: string;
	required: boolean;
	sensitive: boolean;
	defaultValue?: string | null;
	description?: string | null;
};

export type CreateInstitutionDownloadConfigCommandResult = {
	institutionDownloadConfigID: number;
};

export type CreateInstitutionDownloadConfigRequest = {
	institutionCode: string;
	downloaderName: string;
	category: string;
	country: string;
	enabled: boolean;
	configuration?: { [key: string | number]: string } | null;
};

export type UpdateInstitutionDownloadConfigRequest = {
	downloaderName?: string | null;
	enabled?: boolean | null;
	configuration?: { [key: string | number]: string } | null;
	clearConfiguration: boolean;
};

export type TriggerInstitutionDownloadCommandResult = {
	success: boolean;
	uploadedPaths: string[];
	downloadUrls: string[];
};

export type ImportEnvironmentDto = {
	name: string;
	displayName: string;
	localization: string;
	description?: string | null;
	isEnabled: boolean;
};

export type ExecuteCodeListImportCommandResult = {
	success: boolean;
	codeListImportJobID: number;
	definitionsProcessed: number;
	definitionsSkipped: number;
	duration: string;
	messages: string[];
	errors: string[];
	warnings: string[];
	cacheRefreshRequestId?: string | null;
};

export type ExecuteImportRequest = {
	environmentName: string;
	localization: string;
	targetInstances?: string[] | null;
};

export type EntityListOfCodeListImportJobDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: CodeListImportJobDto[];
};

export type CodeListImportJobDto = {
	codeListImportJobID: number;
	localization: string;
	targetEnvironment: string;
	status: ImportJobStatus;
	startedAt: string;
	completedAt?: string | null;
	startedBy: string;
	startedByName?: string | null;
	errorMessage?: string | null;
	definitionsProcessed: number;
	definitionsSkipped: number;
	duration?: string | null;
};

export enum ImportJobStatus {
	Pending = "Pending",
	Running = "Running",
	Completed = "Completed",
	Failed = "Failed",
	Cancelled = "Cancelled"
};

export type SignUpCommandResult = {};

export type ApiProblemDetailsOfSignUpErrorStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum SignUpErrorStatus {
	UserExists = "UserExists"
};

export type ApiProblemDetailsOfPasswordChangeResultStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum PasswordChangeResultStatus {
	PasswordNotMatch = "PasswordNotMatch",
	NullOrEmpty = "NullOrEmpty",
	TooShort = "TooShort",
	Success = "Success"
};

export type SignUpCommand = {
	login: string;
	password: string;
	passwordRepeat: string;
	firstName: string;
	lastName: string;
};

export type SignInResult = {
	userInfo: UserInfo;
	isFirstSignIn: boolean;
};

export type UserInfo = {
	token: string;
	userID: number;
	login: string;
	firstName: string;
	lastName: string;
	userIdentityProviders: IdentityProvider[];
	accessRightCodes: string[];
	accessRoles: string[];
	profilePicture?: string | null;
};

export type ApiProblemDetailsOfAuthError = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum AuthError {
	ApplicationVerification = "ApplicationVerification",
	InvalidCredentials = "InvalidCredentials",
	AccountIsDisabled = "AccountIsDisabled",
	AccountNotFound = "AccountNotFound",
	PhoneNumberNotFound = "PhoneNumberNotFound",
	SmsSendingFailed = "SmsSendingFailed",
	InvalidToken = "InvalidToken",
	AccountWaitingForEmailConfirmation = "AccountWaitingForEmailConfirmation"
};

export type SignInCommand = {
	login: string;
	password: string;
};

export type EmailVerificationCommandResult = {
	signInResult: SignInResult;
};

export type ApiProblemDetailsOfEmailVerificationCommandResultStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum EmailVerificationCommandResultStatus {
	TokenNotFound = "TokenNotFound",
	UserNotFound = "UserNotFound"
};

export type EmailVerificationCommand = {
	token: string;
};

export type ResendVerificationEmailCommandResult = {};

export type ResendVerificationEmailCommand = {
	email: string;
};

export type SsoSignInRequest = {
	token: string;
	identityProvider: IdentityProvider;
};

export type ResetPasswordCommandResult = {};

export type ApiProblemDetailsOfResetPasswordCommandResultStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum ResetPasswordCommandResultStatus {
	Fail = "Fail"
};

export type ResetPasswordCommand = {
	login: string;
};

export type SetPasswordCommandResult = {};

export type ApiProblemDetailsOfSetPasswordCommandStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum SetPasswordCommandStatus {
	UserNotFound = "UserNotFound"
};

export type SetPasswordCommand = {
	login: string;
	password: string;
};

export type GetAiUsageQueryResult = {
	instances: AiUsageInstanceDto[];
	notRespondingDeviceNames: string[];
	dateCollected: string;
};

export type AiUsageInstanceDto = {
	deviceName: string;
	deviceLocalization?: string | null;
	deviceCategory?: DeviceCategory | null;
	appInstanceName?: string | null;
	isSelfInsurance: boolean;
	isSuccess: boolean;
	errorDescription?: string | null;
	items: AiUsageStatisticDto[];
};

export enum DeviceCategory {
	Client = "Client",
	Internal = "Internal",
	Demo = "Demo"
};

export type AiUsageStatisticDto = {
	year: number;
	month: number;
	source: number;
	sourceName: string;
	aiModel: string;
	isSysAdmin: boolean;
	count: number;
};

export type ExportAiUsageCommand = {
	year: number;
	sources: number[];
	excludeSysAdmins: boolean;
	deviceNames: string[];
	includeDetail: boolean;
	modelPrices: AiModelPriceDto[];
};

export type AiModelPriceDto = {
	aiModel?: string | null;
	inputPricePerMillion: number;
	cachedInputPricePerMillion: number;
	outputPricePerMillion: number;
};

export type EntityListOfActionHistoryDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: ActionHistoryDto[];
};

export type ActionHistoryDto = {
	actionID: number;
	requestID?: string | null;
	actionType: number;
	actionTypeName: string;
	messageJson: string;
	filteredDeviceNames?: string | null;
	requestIsSuccess: boolean;
	requestResultText?: string | null;
	responseIsSuccess?: boolean | null;
	responseResultText?: string | null;
	note?: string | null;
	dateCreated: string;
	createdByName?: string | null;
};

export type GetApiUsersFetchResponse = 
| FetchResponse<EntityListOfUserListItemDto, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiUsersPath = () => `/api/v1/users`;

export const getApiUsers = (offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetApiUsersFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getApiUsersPath()}`, options, queryParams) as Promise<GetApiUsersFetchResponse>;
}

export type PutApiUsersFetchResponse = 
| FetchResponse<UserDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putApiUsersPath = () => `/api/v1/users`;

export const putApiUsers = (requestContract: UpdateUserQuery, options?: FetchArgsOptions):
  Promise<PutApiUsersFetchResponse> => {
    const requestData = getApiRequestData<UpdateUserQuery>(requestContract, false);

    return apiPut(`${getApiUrl()}${putApiUsersPath()}`, requestData, options) as Promise<PutApiUsersFetchResponse>;
}

export type GetApiUsersUserIDFetchResponse = 
| FetchResponse<UserDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiUsersUserIDPath = (userID: number) => `/api/v1/users/${userID}`;

export const getApiUsersUserID = (userID: number, options?: FetchArgsOptions):
  Promise<GetApiUsersUserIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getApiUsersUserIDPath(userID)}`, options, {}) as Promise<GetApiUsersUserIDFetchResponse>;
}

export type DeleteApiUsersUserIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const deleteApiUsersUserIDPath = (userID: number) => `/api/v1/users/${userID}`;

export const deleteApiUsersUserID = (userID: number, options?: FetchArgsOptions):
  Promise<DeleteApiUsersUserIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteApiUsersUserIDPath(userID)}`, options, {}) as Promise<DeleteApiUsersUserIDFetchResponse>;
}

export type PutApiNotificationsUserSettingsFetchResponse = 
| FetchResponse<SaveUserNotificationSettingsCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putApiNotificationsUserSettingsPath = () => `/api/v1/notifications/user-settings`;

export const putApiNotificationsUserSettings = (requestContract: UserNotificationUpdateRequest, options?: FetchArgsOptions):
  Promise<PutApiNotificationsUserSettingsFetchResponse> => {
    const requestData = getApiRequestData<UserNotificationUpdateRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putApiNotificationsUserSettingsPath()}`, requestData, options) as Promise<PutApiNotificationsUserSettingsFetchResponse>;
}

export type PostApiDevicesExportFetchResponse = 
| FetchResponse<MemoryStream, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiDevicesExportPath = () => `/api/v1/devices/export`;

export const postApiDevicesExport = (requestContract: ExportDevicesCommand, options?: FetchArgsOptions):
  Promise<PostApiDevicesExportFetchResponse> => {
    const requestData = getApiRequestData<ExportDevicesCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiDevicesExportPath()}`, requestData, options) as Promise<PostApiDevicesExportFetchResponse>;
}

export type GetApiCodeListsFetchResponse = 
| FetchResponse<GetCodeListCollectionQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiCodeListsPath = () => `/api/v1/code-lists`;

export const getApiCodeLists = (options?: FetchArgsOptions):
  Promise<GetApiCodeListsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getApiCodeListsPath()}`, options, {}) as Promise<GetApiCodeListsFetchResponse>;
}

export type GetApiCodelistManagementFilesFetchResponse = 
| FetchResponse<CodeListFileDto[], 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiCodelistManagementFilesPath = () => `/api/v1/codelist-management/files`;

export const getApiCodelistManagementFiles = (folderPath?: string | undefined | null, isActive?: boolean | undefined | null, options?: FetchArgsOptions):
  Promise<GetApiCodelistManagementFilesFetchResponse> => {
    const queryParams = {
      "folderPath": folderPath,
      "isActive": isActive
    }
    return apiGet(`${getApiUrl()}${getApiCodelistManagementFilesPath()}`, options, queryParams) as Promise<GetApiCodelistManagementFilesFetchResponse>;
}

export type DeleteApiCodelistManagementFilesFetchResponse = 
| FetchResponse<DeleteCodeListFileCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const deleteApiCodelistManagementFilesPath = () => `/api/v1/codelist-management/files`;

export const deleteApiCodelistManagementFiles = (folderPath?: string, fileName?: string, options?: FetchArgsOptions):
  Promise<DeleteApiCodelistManagementFilesFetchResponse> => {
    const queryParams = {
      "folderPath": folderPath,
      "fileName": fileName
    }
    return apiDelete(`${getApiUrl()}${deleteApiCodelistManagementFilesPath()}`, options, queryParams) as Promise<DeleteApiCodelistManagementFilesFetchResponse>;
}

export type PostApiCodelistManagementFilesFetchResponse = 
| FetchResponse<UploadCodeListFileCommandResult, 201> 
| FetchResponse<ProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiCodelistManagementFilesPath = () => `/api/v1/codelist-management/files`;

export const postApiCodelistManagementFiles = (options?: FetchArgsOptions):
  Promise<PostApiCodelistManagementFilesFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postApiCodelistManagementFilesPath()}`, requestData, options) as Promise<PostApiCodelistManagementFilesFetchResponse>;
}

export type GetApiCodelistManagementFilesVersionsFetchResponse = 
| FetchResponse<CodeListFileDto[], 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiCodelistManagementFilesVersionsPath = () => `/api/v1/codelist-management/files/versions`;

export const getApiCodelistManagementFilesVersions = (folderPath?: string, fileName?: string, options?: FetchArgsOptions):
  Promise<GetApiCodelistManagementFilesVersionsFetchResponse> => {
    const queryParams = {
      "folderPath": folderPath,
      "fileName": fileName
    }
    return apiGet(`${getApiUrl()}${getApiCodelistManagementFilesVersionsPath()}`, options, queryParams) as Promise<GetApiCodelistManagementFilesVersionsFetchResponse>;
}

export type PostApiCodelistManagementFilesIdActivateFetchResponse = 
| FetchResponse<ActivateCodeListFileVersionCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiCodelistManagementFilesIdActivatePath = (id: number) => `/api/v1/codelist-management/files/${id}/activate`;

export const postApiCodelistManagementFilesIdActivate = (id: number, options?: FetchArgsOptions):
  Promise<PostApiCodelistManagementFilesIdActivateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postApiCodelistManagementFilesIdActivatePath(id)}`, requestData, options) as Promise<PostApiCodelistManagementFilesIdActivateFetchResponse>;
}

export type GetApiCodelistManagementDownloadConfigsFetchResponse = 
| FetchResponse<GetInstitutionDownloadConfigsQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiCodelistManagementDownloadConfigsPath = () => `/api/v1/codelist-management/download-configs`;

export const getApiCodelistManagementDownloadConfigs = (enabled?: boolean | undefined | null, offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetApiCodelistManagementDownloadConfigsFetchResponse> => {
    const queryParams = {
      "enabled": enabled,
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getApiCodelistManagementDownloadConfigsPath()}`, options, queryParams) as Promise<GetApiCodelistManagementDownloadConfigsFetchResponse>;
}

export type PostApiCodelistManagementDownloadConfigsFetchResponse = 
| FetchResponse<CreateInstitutionDownloadConfigCommandResult, 201> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 409> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiCodelistManagementDownloadConfigsPath = () => `/api/v1/codelist-management/download-configs`;

export const postApiCodelistManagementDownloadConfigs = (requestContract: CreateInstitutionDownloadConfigRequest, options?: FetchArgsOptions):
  Promise<PostApiCodelistManagementDownloadConfigsFetchResponse> => {
    const requestData = getApiRequestData<CreateInstitutionDownloadConfigRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiCodelistManagementDownloadConfigsPath()}`, requestData, options) as Promise<PostApiCodelistManagementDownloadConfigsFetchResponse>;
}

export type PutApiCodelistManagementDownloadConfigsIdFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putApiCodelistManagementDownloadConfigsIdPath = (id: number) => `/api/v1/codelist-management/download-configs/${id}`;

export const putApiCodelistManagementDownloadConfigsId = (requestContract: UpdateInstitutionDownloadConfigRequest, id: number, options?: FetchArgsOptions):
  Promise<PutApiCodelistManagementDownloadConfigsIdFetchResponse> => {
    const requestData = getApiRequestData<UpdateInstitutionDownloadConfigRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putApiCodelistManagementDownloadConfigsIdPath(id)}`, requestData, options) as Promise<PutApiCodelistManagementDownloadConfigsIdFetchResponse>;
}

export type PostApiCodelistManagementDownloadConfigsIdTriggerFetchResponse = 
| FetchResponse<TriggerInstitutionDownloadCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiCodelistManagementDownloadConfigsIdTriggerPath = (id: number) => `/api/v1/codelist-management/download-configs/${id}/trigger`;

export const postApiCodelistManagementDownloadConfigsIdTrigger = (id: number, options?: FetchArgsOptions):
  Promise<PostApiCodelistManagementDownloadConfigsIdTriggerFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postApiCodelistManagementDownloadConfigsIdTriggerPath(id)}`, requestData, options) as Promise<PostApiCodelistManagementDownloadConfigsIdTriggerFetchResponse>;
}

export type GetApiCodelistManagementImportEnvironmentsFetchResponse = 
| FetchResponse<ImportEnvironmentDto[], 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiCodelistManagementImportEnvironmentsPath = () => `/api/v1/codelist-management/import/environments`;

export const getApiCodelistManagementImportEnvironments = (options?: FetchArgsOptions):
  Promise<GetApiCodelistManagementImportEnvironmentsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getApiCodelistManagementImportEnvironmentsPath()}`, options, {}) as Promise<GetApiCodelistManagementImportEnvironmentsFetchResponse>;
}

export type PostApiCodelistManagementImportFetchResponse = 
| FetchResponse<ExecuteCodeListImportCommandResult, 200> 
| FetchResponse<ProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiCodelistManagementImportPath = () => `/api/v1/codelist-management/import`;

export const postApiCodelistManagementImport = (requestContract: ExecuteImportRequest, options?: FetchArgsOptions):
  Promise<PostApiCodelistManagementImportFetchResponse> => {
    const requestData = getApiRequestData<ExecuteImportRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiCodelistManagementImportPath()}`, requestData, options) as Promise<PostApiCodelistManagementImportFetchResponse>;
}

export type GetApiCodelistManagementImportJobsFetchResponse = 
| FetchResponse<EntityListOfCodeListImportJobDto, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiCodelistManagementImportJobsPath = () => `/api/v1/codelist-management/import-jobs`;

export const getApiCodelistManagementImportJobs = (localization?: string | undefined | null, status?: ImportJobStatus | undefined | null, offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetApiCodelistManagementImportJobsFetchResponse> => {
    const queryParams = {
      "localization": localization,
      "status": status,
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getApiCodelistManagementImportJobsPath()}`, options, queryParams) as Promise<GetApiCodelistManagementImportJobsFetchResponse>;
}

export type PostApiCacheRefreshFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 403> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiCacheRefreshPath = () => `/api/v1/cache/refresh`;

export const postApiCacheRefresh = (body: string, options?: FetchArgsOptions):
  Promise<PostApiCacheRefreshFetchResponse> => {
    const requestData = getApiRequestData<string>(body, false);

    return apiPost(`${getApiUrl()}${postApiCacheRefreshPath()}`, requestData, options) as Promise<PostApiCacheRefreshFetchResponse>;
}

export type PostApiAuthSignUpFetchResponse = 
| FetchResponse<SignUpCommandResult, 201> 
| FetchResponse<ApiProblemDetailsOfPasswordChangeResultStatus, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfSignUpErrorStatus, 409> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiAuthSignUpPath = () => `/api/v1/auth/sign-up`;

export const postApiAuthSignUp = (requestContract: SignUpCommand, options?: FetchArgsOptions):
  Promise<PostApiAuthSignUpFetchResponse> => {
    const requestData = getApiRequestData<SignUpCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiAuthSignUpPath()}`, requestData, options) as Promise<PostApiAuthSignUpFetchResponse>;
}

export type PostApiAuthSignInFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetailsOfAuthError, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiAuthSignInPath = () => `/api/v1/auth/sign-in`;

export const postApiAuthSignIn = (requestContract: SignInCommand, options?: FetchArgsOptions):
  Promise<PostApiAuthSignInFetchResponse> => {
    const requestData = getApiRequestData<SignInCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiAuthSignInPath()}`, requestData, options) as Promise<PostApiAuthSignInFetchResponse>;
}

export type PostApiAuthEmailVerificationFetchResponse = 
| FetchResponse<EmailVerificationCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfEmailVerificationCommandResultStatus, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiAuthEmailVerificationPath = () => `/api/v1/auth/email-verification`;

export const postApiAuthEmailVerification = (requestContract: EmailVerificationCommand, options?: FetchArgsOptions):
  Promise<PostApiAuthEmailVerificationFetchResponse> => {
    const requestData = getApiRequestData<EmailVerificationCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiAuthEmailVerificationPath()}`, requestData, options) as Promise<PostApiAuthEmailVerificationFetchResponse>;
}

export type PostApiAuthEmailVerificationSendFetchResponse = 
| FetchResponse<ResendVerificationEmailCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiAuthEmailVerificationSendPath = () => `/api/v1/auth/email-verification/send`;

export const postApiAuthEmailVerificationSend = (requestContract: ResendVerificationEmailCommand, options?: FetchArgsOptions):
  Promise<PostApiAuthEmailVerificationSendFetchResponse> => {
    const requestData = getApiRequestData<ResendVerificationEmailCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiAuthEmailVerificationSendPath()}`, requestData, options) as Promise<PostApiAuthEmailVerificationSendFetchResponse>;
}

export type PostApiAuthSsoFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfAuthError, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiAuthSsoPath = () => `/api/v1/auth/sso`;

export const postApiAuthSso = (requestContract: SsoSignInRequest, options?: FetchArgsOptions):
  Promise<PostApiAuthSsoFetchResponse> => {
    const requestData = getApiRequestData<SsoSignInRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiAuthSsoPath()}`, requestData, options) as Promise<PostApiAuthSsoFetchResponse>;
}

export type PostApiAuthPasswordResetFetchResponse = 
| FetchResponse<ResetPasswordCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfResetPasswordCommandResultStatus, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiAuthPasswordResetPath = () => `/api/v1/auth/password-reset`;

export const postApiAuthPasswordReset = (requestContract: ResetPasswordCommand, options?: FetchArgsOptions):
  Promise<PostApiAuthPasswordResetFetchResponse> => {
    const requestData = getApiRequestData<ResetPasswordCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiAuthPasswordResetPath()}`, requestData, options) as Promise<PostApiAuthPasswordResetFetchResponse>;
}

export type PutApiAuthPasswordFetchResponse = 
| FetchResponse<SetPasswordCommandResult, 200> 
| FetchResponse<ApiProblemDetailsOfPasswordChangeResultStatus, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfSetPasswordCommandStatus, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putApiAuthPasswordPath = () => `/api/v1/auth/password`;

export const putApiAuthPassword = (requestContract: SetPasswordCommand, options?: FetchArgsOptions):
  Promise<PutApiAuthPasswordFetchResponse> => {
    const requestData = getApiRequestData<SetPasswordCommand>(requestContract, false);

    return apiPut(`${getApiUrl()}${putApiAuthPasswordPath()}`, requestData, options) as Promise<PutApiAuthPasswordFetchResponse>;
}

export type GetApiAuthUserinfoFetchResponse = 
| FetchResponse<UserInfo, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiAuthUserinfoPath = () => `/api/v1/auth/userinfo`;

export const getApiAuthUserinfo = (options?: FetchArgsOptions):
  Promise<GetApiAuthUserinfoFetchResponse> => {
    return apiGet(`${getApiUrl()}${getApiAuthUserinfoPath()}`, options, {}) as Promise<GetApiAuthUserinfoFetchResponse>;
}

export type GetApiAiUsageFetchResponse = 
| FetchResponse<GetAiUsageQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiAiUsagePath = () => `/api/v1/ai-usage`;

export const getApiAiUsage = (options?: FetchArgsOptions):
  Promise<GetApiAiUsageFetchResponse> => {
    return apiGet(`${getApiUrl()}${getApiAiUsagePath()}`, options, {}) as Promise<GetApiAiUsageFetchResponse>;
}

export type PostApiAiUsageExportFetchResponse = 
| FetchResponse<MemoryStream, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postApiAiUsageExportPath = () => `/api/v1/ai-usage/export`;

export const postApiAiUsageExport = (requestContract: ExportAiUsageCommand, options?: FetchArgsOptions):
  Promise<PostApiAiUsageExportFetchResponse> => {
    const requestData = getApiRequestData<ExportAiUsageCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postApiAiUsageExportPath()}`, requestData, options) as Promise<PostApiAiUsageExportFetchResponse>;
}

export type GetApiActionHistoryFetchResponse = 
| FetchResponse<EntityListOfActionHistoryDto, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getApiActionHistoryPath = () => `/api/v1/action-history`;

export const getApiActionHistory = (offset?: number, limit?: number, types?: string | undefined | null, device?: string | undefined | null, requestId?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetApiActionHistoryFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit,
      "types": types,
      "device": device,
      "requestId": requestId
    }
    return apiGet(`${getApiUrl()}${getApiActionHistoryPath()}`, options, queryParams) as Promise<GetApiActionHistoryFetchResponse>;
}
